import React from 'react';
import { CheckCircle2, Shield, Lock, CreditCard, FileText, Zap, BookOpen } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-slate-900 text-white min-h-[100svh] flex flex-col justify-center pt-6 pb-8 md:pt-20 md:pb-16 px-4 relative overflow-hidden" data-id="element-117">
      {/* Lightweight CSS decoration (no network image) */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-3xl" data-id="element-118"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-emerald-600/10 rounded-full blur-3xl" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center w-full" data-id="element-120">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-xs md:text-sm font-medium mb-3 md:mb-6 border border-blue-500/30" data-id="element-121">
          <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" data-id="element-122"></span>
          PROFE LISTO · GIMNASIA ARTÍSTICA 360
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-6xl font-extrabold tracking-tight mb-3 md:mb-8 leading-tight" data-id="element-123">
          Todo tu año de gimnasia <br className="hidden md:block" data-id="element-124" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400" data-id="element-125">
            resuelto de una vez.
          </span>
        </h1>

        <div className="max-w-2xl mx-auto mb-3 md:mb-8" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/m2YFZzSBoAVstptV4mEQBH/g_artistica_mock.png" alt="Megapack Gimnasia Artística 360 — 12 Tomos + 6 Bonus + 2 Ebooks Élite" width={1080} height={1350} fetchPriority="high" decoding="async" className="w-auto max-h-[32svh] md:max-h-none md:w-full mx-auto h-auto drop-shadow-2xl object-contain" data-id="element-127" />
        </div>

        <p className="text-sm sm:text-base md:text-xl text-slate-300 max-w-3xl mx-auto mb-4 md:mb-10 leading-snug md:leading-relaxed" data-id="element-128">
          <strong className="text-white" data-id="element-129">
            Megapack GIMNASIA ARTÍSTICA 360
          </strong>{' '}
          — El sistema completo de planificación, progresiones y secuencias para
          el profesor de gimnasia artística argentino.
        </p>

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-8 mb-4 md:mb-10 text-xs md:text-base text-slate-300" data-id="element-130">
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-131">
            <FileText className="w-4 h-4 md:w-5 md:h-5 text-blue-400" data-id="element-132" /> PDF
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-133">
            <Zap className="w-4 h-4 md:w-5 md:h-5 text-yellow-400" data-id="element-134" /> Acceso
            Inmediato
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-135">
            <BookOpen className="w-4 h-4 md:w-5 md:h-5 text-emerald-400" data-id="element-136" /> 12
            Tomos + 6 Bonus + 2 Élite
          </div>
        </div>

        <button onClick={scrollToPricing} className="w-full md:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-bold text-base md:text-xl py-3.5 md:py-4 px-10 rounded-full shadow-[0_0_40px_rgba(37,99,235,0.3)] hover:shadow-[0_0_60px_rgba(37,99,235,0.5)] transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto" data-id="element-137">
          💪 QUIERO MI GIMNASIA 360 AHORA
        </button>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-4 md:mt-8 text-xs md:text-sm text-slate-400" data-id="element-138">
          <div className="flex items-center gap-2" data-id="element-139">
            <Shield className="w-4 h-4" data-id="element-140" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-141">
            <Lock className="w-4 h-4" data-id="element-142" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-143">
            <CreditCard className="w-4 h-4" data-id="element-144" /> Tarjetas y transferencia
          </div>
        </div>
      </div>
    </section>;
}